import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';

export interface ClassSectionState {
  class_section_id: number;
  class_section_year: number;
  class_section_semester: number;
  class_section_subject: string;
  class_section_grade: number;
  class_section_name: string;
  displayName?: string;
}

const initialState: ClassSectionState = {
  class_section_id: -1,
  class_section_year: 0,
  class_section_semester: 0,
  class_section_subject: '',
  class_section_grade: 0,
  class_section_name: '',
  displayName: '',
};

export const classSectionSlice = createSlice({
  name: 'classSection',
  initialState,
  reducers: {
    selected(_, action: PayloadAction<ClassSectionState>) {
      return action.payload;
    },
    reset() {
      return initialState;
    },
  },
});

export const selected = (classSection: ClassSectionState) => ({
  type: 'classSection/selected',
  payload: classSection,
});

export const reset = createAction('classSection/reset');

export default classSectionSlice.reducer;
